export const PlaceMissionType = ['플레이스 트래픽', '플레이스 저장하기','플레이스 명소 맞추기','플레이스 전화번호 맞추기','플레이스 사진 URL 맞추기','플레이스 URL 맞추기']

export enum PlaceMissionTypeEnum {
    /**
     *  상위 레벨
     */
    PlaceTraffic = 1 << 0,   // 1
    PlaceSave    = 1 << 1,   // 2

    /**
     *  하위 레벨 – PlaceTraffic이 동시에 켜질 때만 함께 올 수 있음
     */
    Attraction   = 1 << 2,   // 4
    Telephone    = 1 << 3,   // 8
    PictureUrl   = 1 << 4,   // 16
    Url          = 1 << 5,   // 32
}

/**
 * 플레이스 미션 타입에 따른 문구
 * */
export const PlacePathTypeString: Record<PlaceMissionTypeEnum, string> = {
    [PlaceMissionTypeEnum.PlaceTraffic]: '전체 상품번호를 입력해주세요!',
    [PlaceMissionTypeEnum.PlaceSave]   : '링크를 입력해주세요!',
    [PlaceMissionTypeEnum.Attraction]  : '명소를 입력해주세요!',
    [PlaceMissionTypeEnum.Telephone]   : '전화번호를 입력해주세요!',
    [PlaceMissionTypeEnum.PictureUrl]  : '사진 URL을 입력해주세요!',
    [PlaceMissionTypeEnum.Url]         : 'URL을 입력해주세요!',
} as const;

/**
 * 플레이스 미션 타입에 따른 색상
 * */
export const PlacePathTypeColor: Record<PlaceMissionTypeEnum, string> = {
    [PlaceMissionTypeEnum.PlaceTraffic]: '#000000', /** 쓰지 않음 */
    [PlaceMissionTypeEnum.PlaceSave]   : '#5CD699',
    [PlaceMissionTypeEnum.Attraction]  : '#7FA8FF',
    [PlaceMissionTypeEnum.Telephone]   : '#B7A6FF',
    [PlaceMissionTypeEnum.PictureUrl]  : '#78DDFF',
    [PlaceMissionTypeEnum.Url]         : '#E3A0FA', // TODO PlaceMissionType.Url
} as const;


/**
 * 플레이스 미션 타입에 따른 값 반환 함수
 * */
export function resolvePlacePathType(mask: number | undefined | null,item: Record<PlaceMissionTypeEnum, string>): string {
    if(mask === null || mask === undefined) return '';

    /** 상위 미션 타입 먼저 검사 */
    if (mask & PlaceMissionTypeEnum.PlaceSave) {
        return item[PlaceMissionTypeEnum.PlaceSave];
    }

    /** PlaceTraffic이 켜진 경우 → 하위 미션을 하나만 찾으면 됨 */
    if (mask & PlaceMissionTypeEnum.PlaceTraffic) {
        if (mask & PlaceMissionTypeEnum.Attraction) {
            return item[PlaceMissionTypeEnum.Attraction];
        }
        if (mask & PlaceMissionTypeEnum.Telephone) {
            return item[PlaceMissionTypeEnum.Telephone];
        }
        if (mask & PlaceMissionTypeEnum.PictureUrl) {
            return item[PlaceMissionTypeEnum.PictureUrl];
        }
        if (mask & PlaceMissionTypeEnum.Url) {
            return item[PlaceMissionTypeEnum.Url];
        }
        /** 하위 플래그가 없다면 기본값 */
        return item[PlaceMissionTypeEnum.PlaceTraffic];
    }

    /** 어떤 플래그도 매칭되지 않으면 빈 문자열 반환 (필요 시 예외 처리) */
    return '';
}